import React, { useState } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  // ResponsiveContainer,
} from "recharts";

const data = [
  { name: "A", pv: 2400 },
  { name: "B", pv: 1398 },
  { name: "C", pv: 9800 },
  { name: "D", pv: 3908 },
  { name: "E", pv: 4800 },
  { name: "F", pv: 3490 },
  { name: "G", pv: 1300 },
];

const RequestChart = () => {
  const [chartData] = useState(data);

  return (
    <ResponsiveContainer width="100%" height={300}>
      <LineChart
        width={500}
        height={300}
        data={chartData}
        margin={{
          top: 5,
          right: 30,
          left: 20,
          bottom: 5,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Line
          type="monotone"
          dataKey="pv"
          strokeWidth={2}
          stroke="#EE3E38"
          activeDot={{ r: 8 }}
        />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default RequestChart;
